export enum DrawerOpenedMethod {
    ByHand = 'ByHand',
    ByCommand = 'ByCommand'
}